import React, { useEffect, useState } from 'react';
import JitsiMeetComponent from '../components/JitsiMeetComponent';
import { getUserName } from '../utils/localStoarege';
import { getOnGOingCalls, joinOngoingMeeting, startNewMeeting } from '../services/new_clinic/video_call';
import { toast } from 'react-toastify';

function VideoCall({ role }) {
    const [roomName, setRoomName] = useState(getUserName());
    const name = (role === "operator" ? `${getUserName()} Operator` : "Admin");
    const [startCall, setStartCall] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pendingCalls, setPendingCalls] = useState([]);
    const [JWT, setJWT] = useState(null);

    const handleStart = async () => {
        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append("clinic_name", getUserName());
            const response = await startNewMeeting(formData);

            if (response?.status === 200) {
                setStartCall(true);
                setJWT(response.data.jwt);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setIsLoading(false);
    };

    const fetchOngoingCalls = async () => {
        setIsLoading(true);
        try {
            const response = await getOnGOingCalls();
            if (response?.status === 200) {
                setPendingCalls(response.data);
            } else {
                let errors = "Unable to get ongoing calls. Try refreshing!!!";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setIsLoading(false);
    };

    const handleEnd = () => {
        setIsLoading(false);
        setStartCall(false);
        fetchOngoingCalls();
    };


    const handleDoctorJoin = async ({ meetingDetails }) => {
        setIsLoading(true);
        try {
            const response = await joinOngoingMeeting(meetingDetails.id);

            if (response?.status === 200) {
                setStartCall(true);
                setRoomName(meetingDetails.clinic);
                setJWT(response.data.jwt);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (role !== "operator" && !startCall) {
            fetchOngoingCalls();
            const interval = setInterval(fetchOngoingCalls, 10000);
            return () => clearInterval(interval);
        }
    }, [role, startCall])

    return (
        <div>
            {!startCall ? (
                role === "operator" ?
                    <div className="max-w-md mx-auto bg-white p-8 rounded-2xl shadow-xl space-y-6 transform transition-all duration-300 hover:shadow-2xl">
                        <div className="text-center space-y-2">
                            <div className="w-20 h-20 mx-auto rounded-full bg-blue-100 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h1 className="text-3xl font-bold text-gray-800">Video Meeting</h1>
                            <p className="text-gray-600">Start a secure video consultation</p>
                        </div>

                        <button
                            onClick={handleStart}
                            disabled={isLoading}
                            className={`w-full py-3 px-4 rounded-xl text-white font-medium transition-all duration-300 flex items-center justify-center space-x-2 ${isLoading ? 'bg-blue-400' : 'bg-primary hover:bg-blue-700 hover:shadow-md'
                                }`}
                        >
                            {isLoading ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Connecting...
                                </>
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                    </svg>
                                    <span>Join Meeting</span>
                                </>
                            )}
                        </button>

                        <div className="text-center text-sm text-gray-500">
                            <p>Secure, encrypted video consultations</p>
                        </div>
                    </div> :
                    <div className="max-w-md mx-auto bg-white p-8 rounded-2xl shadow-xl space-y-6 transform transition-all duration-300 hover:shadow-2xl">
                        <div className="flex flex-row items-center justify-center text-center gap-2">
                            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h1 className="text-2xl font-bold text-gray-800">Join meeting</h1>
                        </div>
                        <p className="text-gray-600 text-center">Pending Video Meetings</p>
                        {
                            isLoading ?
                                <></> :
                                pendingCalls.length > 0 ? (
                                    <div className="space-y-4">
                                        {pendingCalls.map(call => (
                                            <div
                                                key={call.id}
                                                className="flex items-center justify-between border p-3 rounded-lg bg-gray-100 hover:bg-gray-200 transition"
                                            >
                                                <span className="text-gray-800 font-medium">{call.clinic} <small>({call.requested})</small></span>
                                                <button
                                                    onClick={() => {
                                                        handleDoctorJoin({ meetingDetails: call });
                                                    }}
                                                    className="bg-primary hover:bg-primary/85 text-white px-4 py-2 rounded"
                                                    disabled={isLoading}
                                                >
                                                    Join Now
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center text-gray-500 text-sm mt-4">
                                        No meetings available to join.
                                    </div>
                                )
                        }
                        <div className="text-center text-sm text-gray-500">
                            <p>Secure, encrypted video consultations</p>
                        </div>
                    </div>
            ) : (
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <JitsiMeetComponent roomName={roomName} displayName={name} onCallEnd={handleEnd} jwtToken={JWT} />
                </div>
            )}
        </div>
    );
}

export default VideoCall;